import { __decorate } from "tslib";
import { AccessGuard, FrontendFeaturePlugin, accessGuardData, provideRootRoutes } from '@core/frontend-shared';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import { NgxsModule } from '@ngxs/store';
import { MaintenanceInfoIconComponent } from './info-icon/info-icon.component';
import { MaintenanceState } from './state/maintenance.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
let MaintenanceFrontendAdminFeature = /*#__PURE__*/(() => {
  let MaintenanceFrontendAdminFeature = class MaintenanceFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/maintenance/frontend-admin","featureId":"common-maintenance"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Wartung & Tools',
          routerLink: 'maintenance',
          icon: 'wrench',
          simpleAbilityCheck: UserRole.SUPERUSER,
          priority: -1
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMaintenanceFrontendAdminFeature_BaseFactory;
        return function MaintenanceFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMaintenanceFrontendAdminFeature_BaseFactory || (ɵMaintenanceFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MaintenanceFrontendAdminFeature)))(__ngFactoryType__ || MaintenanceFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MaintenanceFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'maintenance',
          canActivate: [AccessGuard],
          data: {
            ...accessGuardData({
              allow: [UserRole.SUPERUSER]
            })
          },
          loadChildren: () => import('./maintenance-admin.module').then(m => m.MaintenanceFrontendAdminModule)
        }])],
        imports: [NgxsModule.forFeature([MaintenanceState]), MaintenanceInfoIconComponent]
      });
    }
  };
  MaintenanceFrontendAdminFeature = __decorate([ClassName("MaintenanceFrontendAdminFeature")], MaintenanceFrontendAdminFeature);
  return MaintenanceFrontendAdminFeature;
})();
export { MaintenanceFrontendAdminFeature };